"use strict";
import { __exports as s } from "./index.es302.js";
var a;
function p() {
  return a ? s : (a = 1, (function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    });
    function c(r, e) {
      for (var n in e) Object.defineProperty(r, n, {
        enumerable: !0,
        get: e[n]
      });
    }
    c(i, {
      assign: function() {
        return g;
      },
      searchParamsToUrlQuery: function() {
        return y;
      },
      urlQueryToSearchParams: function() {
        return l;
      }
    });
    function y(r) {
      const e = {};
      for (const [n, t] of r.entries()) {
        const o = e[n];
        typeof o > "u" ? e[n] = t : Array.isArray(o) ? o.push(t) : e[n] = [
          o,
          t
        ];
      }
      return e;
    }
    function f(r) {
      return typeof r == "string" ? r : typeof r == "number" && !isNaN(r) || typeof r == "boolean" ? String(r) : "";
    }
    function l(r) {
      const e = new URLSearchParams();
      for (const [n, t] of Object.entries(r))
        if (Array.isArray(t))
          for (const o of t)
            e.append(n, f(o));
        else
          e.set(n, f(t));
      return e;
    }
    function g(r) {
      for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), t = 1; t < e; t++)
        n[t - 1] = arguments[t];
      for (const o of n) {
        for (const u of o.keys())
          r.delete(u);
        for (const [u, d] of o.entries())
          r.append(u, d);
      }
      return r;
    }
  })(s), s);
}
export {
  p as __require
};
//# sourceMappingURL=index.es273.js.map
